import axios from "axios"
import { API_GET_USERS_DATA, API_INSERT_USER_DATA, API_TOGGLE_USER_DATA, API_UPDATE_USER_DATA } from "."

export const getUsersList = async (func, config) => {
    return axios.get(API_GET_USERS_DATA, config).then(res => func(res.data.data));
};

export const insertUserData = async (data, config) => {
    return axios.post(API_INSERT_USER_DATA, data, config).then((res) => res.data);
};

export const updateUserData = async (data, config) => {
    return axios.post(API_UPDATE_USER_DATA, data, config).then((res) => res.data);
};

export const toggleUserData = async (data, config, cb) => {
    return axios.put(API_TOGGLE_USER_DATA, data, config).then((res) => {
        if (res.data.status === "success") {
            cb();
        };
    });
};